import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TelephonyMainComponent } from './containers/telephony-main/telephony-main.component';
import { SingleEquipmentComponent } from './containers/single-equipment/single-equipment.component'
import { EquipmentMainComponent } from './containers/equipment-main/equipment-main.component';
import { ConnectivityMainComponent } from './containers/connectivity-main/connectivity-main.component';
const routes: Routes = [
  // TODO: uncomment and modify when implement the module
  {
    path: '',
    component: EquipmentMainComponent,
  //   children: [
  //     { path: ':id/details', component: CompanyDetailsComponent },
  //     { path: ':id/dids', component: CompanyDidsComponent },
  //     { path: ':id/users', component: CompanyUsersComponent },
  //     { path: ':id/fax', component: CompanyFaxComponent },
  //     { path: ':id/request-trial-kit', component: CompanyRequestTrialComponent },
  //     { path: ':id/queues', component: CompanyQueuesComponent },
  //   ]
  children: [
    {
      path: '', 
      pathMatch: 'full', 
      redirectTo: 'telephony'
    },
    {
      path: 'telephony',
      component: TelephonyMainComponent,
    }, 
    { path: 'telephony/:mac', 
      component: SingleEquipmentComponent 
    },
    {
      path: 'connectivity',
      component: ConnectivityMainComponent
    }
  ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EquipmentRoutingModule { }
